import { Gift, RefreshCw, Megaphone, Camera, Trophy, Medal, Award, BadgeCheck, Instagram } from 'lucide-react';

export const NEON_A = '#FCFF00';
export const NEON_B = '#35FF00';
export const NEON = '#B5FF00';
export const INK = '#090A0C';
export const PAPER = '#F7F8F5';
export const RED = '#E02128';
export const BLUE = '#1E6FD9';
export const GOLD = '#FFB547';
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const GRAD = `linear-gradient(135deg, ${NEON_A} 0%, ${NEON_B} 100%)`;
export const DISPLAY = { fontFamily: "'Anton', 'Roboto', sans-serif", fontWeight: 400, letterSpacing: '0.01em' };
export const WORDMARK = { fontFamily: "'Pantha Extend', Orbitron, sans-serif" };

export const IMG = {
  hexcore: `${API}/static/products/hexcore_n1.png`,
  profoam: `${API}/static/products/profoam_n1.png`,
  ball: `${API}/static/products/ball_neon.png`,
  dlogo: `${API}/static/brand/ig_d_logo.png`,
  leap: `${API}/static/erne/hero_leap.webp`,
  leapCut: `${API}/static/erne/hero_leap_cut.webp`,
  court: `${API}/static/erne/court_night.webp`,
  poster: `${API}/static/erne/erne_poster_card.jpg`,
  medal: `${API}/static/erne/erne_medal.webp`,
  medalOutline: `${API}/static/erne/erne_medal_outline.webp`,
  logo: `${API}/static/erne/erne_logo.png`,
  logoCompact: `${API}/static/erne/erne_logo_compact.png`,
};

export const CATEGORIES = [
  { code: 'U15', label: 'Under 15', tag: 'Rising' },
  { code: 'U18', label: 'Under 18', tag: 'Contender' },
  { code: 'U21', label: 'Under 21', tag: 'Elite' },
];

export const PERKS = [
  { icon: Gift, title: 'One paddle. Yours.', body: 'HexCore Pro or ProFoam Pro, pro-grade, on us.' },
  { icon: RefreshCw, title: 'Replaced after 6 months', body: 'Worn from real play? We swap it after 6 months.' },
  { icon: Megaphone, title: 'Featured by DYSSC', body: 'Your best moments on our site and Instagram.' },
];

export const STEPS = [
  { n: '01', title: 'Sign in', body: 'Create your DYSSC account and step inside.' },
  { n: '02', title: 'Apply', body: 'Your game, your DUPR, your medals. Sign online.' },
  { n: '03', title: 'We review', body: 'Every application is read by a human at DYSSC.' },
  { n: '04', title: 'Take the leap', body: 'Approved players receive their paddle and start repping.' },
];

export const BRING = [
  { icon: BadgeCheck, label: 'DUPR screenshot (if registered)' },
  { icon: Instagram, label: 'Instagram handle' },
  { icon: Camera, label: '1–5 photos of you playing' },
  { icon: Trophy, label: 'Tournament results' },
  { icon: Medal, label: 'Photos of medals' },
  { icon: Award, label: 'Certificates (image or PDF)' },
];

export const FAQ = [
  { q: 'Who can apply?', a: 'Pickleball players in India under 21 who compete and love the game, in three categories: Under 15, Under 18 and Under 21. You don\'t need to be a pro. We look for passion, consistency and how you carry the sport.' },
  { q: 'Is the paddle really free?', a: 'Yes. Accepted players get one DYSSC paddle free of charge. The full terms are in the agreement you read and sign when you apply.' },
  { q: 'Do I need a DUPR rating?', a: 'No. You can apply without one. If you are registered on DUPR, upload a screenshot of your profile: it lets us verify your level instantly, so DUPR-registered players are processed faster.' },
  { q: 'How does the 6-month replacement work?', a: 'After 6 months of active play, if your paddle is worn or damaged from normal use, message us and we\'ll replace it.' },
  { q: 'I\'m under 18. Do I need a parent?', a: 'Yes. Add your parent or guardian\'s name and WhatsApp number when you apply; they sign the agreement on your behalf and receive every update we send you.' },
  { q: 'How long does the review take?', a: 'Usually within a week. Your status is always visible on this page once you\'re signed in.' },
  { q: 'Why did my application get rejected?', a: 'There can be a few reasons, and it isn\'t always about how good you are. Your Instagram profile may be private: we can only review public profiles. You may not have uploaded enough clear photos of yourself playing. Or you may not be registered on DUPR, which makes it harder for us to verify your level. Fix what applies to you and you\'re welcome to apply again.' },
];
